module.exports = __webpack_public_path__ + "static/media/super_pack_fr_printemps_chat.ff19477d.png";